// @react/hooks/usePaymentWebhook.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { paymentWebhookStore } from '@core/stores';

/**
 * React hook for ProviderEvent operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { usePaymentWebhook } from '@react/hooks';
 *
 * const ProviderEventList = observer(() => {
 *   const store = usePaymentWebhook();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function usePaymentWebhook() {
  return paymentWebhookStore;
}
